import React from 'react';
import {
  Card,
  ListRow,
  SkeletonText,
  useBreakpointValue,
  renderListRows,
  useThemedValueSwitch,
} from '@tq/ui-components';
import { useTranslation } from 'react-i18next';

import { ListRowProps, RowDirection } from 'tools';
import { Consultation } from 'types';

export type CaseOfficerDetailsCardProps = {
  consultation?: Consultation;
};
export const CaseOfficerDetailsCard: React.FC<CaseOfficerDetailsCardProps> = ({
  consultation,
}) => {
  const { t } = useTranslation('consultation_summary');
  const { tvs } = useThemedValueSwitch();
  const listItemColumns = useBreakpointValue({ base: '40% 60%', lg: '20% 80%' });
  const rowDirection: RowDirection | undefined = useBreakpointValue({
    base: 'vertical',
    md: 'horizontal',
  });

  if (!consultation) {
    return <SkeletonText noOfLines={3} />;
  }
  const rows: ListRowProps[] = [
    {
      label: t('name', 'Name'),
      value: consultation.caseOfficerName,
    },
    {
      label: t('contact_number', 'Contact number'),
      value: consultation.caseOfficerContactNumber,
    },
    {
      label: t('contact_email', 'Contact email'),
      value: consultation.caseOfficerContactEmail,
    },
  ];
  return (
    <Card py={tvs({ tq: '1.25rem' }, 4)} px={tvs({ tq: '1.25rem' }, 3)}>
      <ListRow
        sx={{
          '& li span': {
            letterSpacing: '-0.2px',
          },
          '& li:not(:last-of-type)': {
            mb: tvs({ tq: '0.5rem' }),
          },
        }}
        listItemColumns={listItemColumns}
      >
        {renderListRows(rows, {
          rowDirection,
          addLabelColons: true,
          p: tvs({ tq: 0 }, 1),
          gridGap: '1.25rem',
        })}
      </ListRow>
    </Card>
  );
};
